var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPolygon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3667_8663)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4 5C4 5.55228 4.44772 6 5 6L19 6C19.5523 6 20 5.55229 20 5C20 4.44772 19.5523 4 19 4L5 4C4.44772 4 4 4.44772 4 5Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.3582 17.9398C17.8773 18.1285 18.451 17.8607 18.6398 17.3417L22.2398 7.44172C22.4285 6.92268 22.1608 6.34892 21.6417 6.16018C21.1227 5.97144 20.5489 6.2392 20.3602 6.75823L16.7602 16.6582C16.5714 17.1773 16.8392 17.751 17.3582 17.9398Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8 19C8 19.5523 8.44772 20 9 20L15 20C15.5523 20 16 19.5523 16 19C16 18.4477 15.5523 18 15 18L9 18C8.44772 18 8 18.4477 8 19Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4 21C4 21.5523 4.44772 22 5 22L9 22C9.55229 22 10 21.5523 10 21L10 17C10 16.4477 9.55229 16 9 16L5 16C4.44772 16 4 16.4477 4 17L4 21ZM6 20L6 18L8 18L8 20L6 20Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14 21C14 21.5523 14.4477 22 15 22L19 22C19.5523 22 20 21.5523 20 21L20 17C20 16.4477 19.5523 16 19 16L15 16C14.4477 16 14 16.4477 14 17L14 21ZM16 20L16 18L18 18L18 20L16 20Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18 7C18 7.55228 18.4477 8 19 8L23 8C23.5523 8 24 7.55229 24 7L24 3C24 2.44772 23.5523 2 23 2L19 2C18.4477 2 18 2.44772 18 3L18 7ZM20 6L20 4L22 4L22 6L20 6Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.74228e-08 7C3.91405e-08 7.55228 0.447715 8 1 8L5 8C5.55229 8 6 7.55229 6 7L6 3C6 2.44772 5.55229 2 5 2L1 2C0.447716 2 4.85396e-07 2.44772 4.37114e-07 3L8.74228e-08 7ZM2 6L2 4L4 4L4 6L2 6Z",
    fill: "currentColor"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3667_8663"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPolygon);
export default __webpack_public_path__ + "static/media/polygon.28953928e84329da20e1b465e4772ca3.svg";
export { ForwardRef as ReactComponent };